import { createSlice } from "@reduxjs/toolkit";

// Initial state matching the admin login response
const initialState = {
  id: null,
  uuid: null,
  firstName: null,
  lastName: null,
  email: null,
  phoneNumber: null,
  country: null,
  isActive: false,
  isPhoneVerified: false,
  isEmailVerified: false,
  accessToken: null,
  refreshToken: null,
  isAuthenticated: false,
  role: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      // Handle both user login {user, tokens} and admin login {admin, accessToken}
      const { user, admin, tokens, accessToken } = action.payload;

      // Use admin data if present, otherwise user data
      const userData = admin || user;
      const tokenData = tokens || { accessToken };

      return {
        ...state,
        // User/Admin data
        id: userData.id,
        uuid: userData.uuid,
        firstName: userData.firstName,
        lastName: userData.lastName,
        email: userData.email,
        phoneNumber: userData.phoneNumber,
        country: userData.country,
        isActive: userData.isActive,
        isPhoneVerified: userData.isPhoneVerified,
        isEmailVerified: userData.isEmailVerified,
        role: userData.role,
        // Tokens
        accessToken: tokenData.accessToken,
        refreshToken: tokenData.refreshToken || null,
        // Set authenticated flag
        isAuthenticated: true,
      };
    },
    logout: (state) => {
      return { ...initialState };
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;
